export default __webpack_public_path__ + "static/media/wedding-sk-logo.3096ce12.svg";